var map = {
	"./block.svg": 688,
	"./bubble.svg": 684,
	"./cocktail.svg": 337,
	"./comb.svg": 932,
	"./cube.svg": 918,
	"./cycle.svg": 905,
	"./exchange.svg": 358,
	"./gnome.svg": 400,
	"./heap.svg": 489,
	"./insertion.svg": 35,
	"./intro.svg": 261,
	"./library.svg": 453,
	"./merge.svg": 455,
	"./odd-even.svg": 171,
	"./quick.svg": 428,
	"./radix.svg": 664,
	"./selection.svg": 492,
	"./shell.svg": 966,
	"./smooth.svg": 83,
	"./tim.svg": 449,
	"./tree.svg": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;